// Versión del sistema
// Se controla con REACT_APP_VERSION (build-time).
// En CI/CD se genera automáticamente con formato YY.MM.DD.
const VERSION = process.env.REACT_APP_VERSION || 'dev';

export default VERSION;
